import ApiClient from '@/api/ApiClient';
import { MessageOkResponse, NurseryHoursDiaryDetailResponse } from 'chaild-api/lib';
import {
  ApproveHoursDiaryRequest,
  ChangeHoursDiaryRequest,
  GetHoursDiaryRequest,
  GetHoursDiarySearchRequest,
  PostHoursDiaryRequest,
} from '@/model/Request';

export default class ApiHoursDiary {
  // GET: 延長保育日誌の一覧を取得する
  public static async searchHoursDiary(
    input: GetHoursDiarySearchRequest
  ): Promise<NurseryHoursDiaryDetailResponse[]> {
    try {
      return await ApiClient.get(
        `/nursery/${input.nurseryId}/nursery-hours-diary/search`,
        { from: input.from, to: input.to, limit: input.limit, skip: input.skip }
      );
    } catch (error) {
      throw error;
    }
  }

  // GET: 延長保育日誌取得(保育園ID, 日付指定)
  public static async getHoursDiary(
    input: GetHoursDiaryRequest
  ): Promise<NurseryHoursDiaryDetailResponse> {
    try {
      return await ApiClient.get(
        `/nursery/${input.nurseryId}/nursery-hours-diary`,
        { date: input.date }
      );
    } catch (error) {
      throw error;
    }
  }

  // POST: 延長保育日誌作成
  public static async postHoursDiary(
    input: PostHoursDiaryRequest
  ): Promise<NurseryHoursDiaryDetailResponse> {
    try {
      return await ApiClient.post(
        `/nursery/${input.nurseryId}/nursery-hours-diary`,
        {
          date: input.date,
          activity: input.activity,
          remarks: input.remarks,
          message: input.message,
          status: input.status,
          appliedBy: input.appliedBy,
          staff: input.staffIds,
        }
      );
    } catch (error) {
      throw error;
    }
  }

  // PUT: 延長保育日誌更新
  public static async putHoursDiary(
    input: ChangeHoursDiaryRequest
  ): Promise<MessageOkResponse> {
    try {
      return await ApiClient.put(
        `/nursery/${input.nurseryId}/nursery-hours-diary/${input.diaryId}`,
        {
          date: input.date,
          activity: input.activity,
          remarks: input.remarks,
          message: input.message,
          status: input.status,
          appliedBy: input.appliedBy,
          staff: input.staffIds,
        }
      );
    } catch (error) {
      throw error;
    }
  }

  // DELETE: 延長保育日誌削除
  public static async deleteHoursDiary(
    input: ChangeHoursDiaryRequest
  ): Promise<MessageOkResponse> {
    try {
      return await ApiClient.delete(
        `/nursery/${input.nurseryId}/nursery-hours-diary/${input.diaryId}`,
        null
      );
    } catch (error) {
      throw error;
    }
  }

  // PUT: 延長保育日誌の承認状態更新
  public static async approveHoursDiary(
    input: ApproveHoursDiaryRequest
  ): Promise<NurseryHoursDiaryDetailResponse> {
    try {
      return await ApiClient.put(
        `/nursery/${input.nurseryId}/nursery-hours-diary/${input.diaryId}/approval`,
        { approvalStatus: input.approvalStatus }
      );
    } catch (error) {
      throw error;
    }
  }
}
